<template>
  <div class="review-questions">
    <Mp3AfterReading :list="mp3List" @changeType="changeType"></Mp3AfterReading>
    <pop-tips
      @handConfirm="handConfirm"
      @handleCloseTip="handleCloseTip"
      :dialogVisable="dialogVisable"
      :popTipsCont="popTipsCont"
    ></pop-tips>
  </div>
</template>
<script>
import Mp3AfterReading from "@/components/StudyCenter/Mp3/Mp3AfterReading"; // 图片轮播跟读
import PopTips from "@/components/popTips";
import Mp3Http from "../mp3";
export default {
  name: "review-questions",
  data() {
    return {
      title: "小儿童美语二级",
      showOk: false,
      type: 1,
      dialogVisable: false,

      mp3List: [],
      popTipsCont: {
        title: this.$t('blendType.reword'),
        context: `<span class="gold"></span> +4`,
        btns: [
          {
            text: this.$t('Common.confirm'),
            event: "handConfirm"
          }
        ]
      }
    };
  },
  created() {
    this.student_id = this.$store.state.currentChild.student_id;
    this.id = this.$route.query.id;
    this.classcode_branch = this.$store.state.currentChild.classcode_branch;

    this.getVoices(this.id);
  },
  components: {
    PopTips,
    Mp3AfterReading
  },
  methods: {
    bakToPrev() {
      // this.$router.push({ path: "/StudyCenter" });
      console.log("bakToPrev");
    },
    getData() {
      console.log("getData");
    },
    changeType(v) {
      console.log(v);
    },
    submitOk() {
      this.dialogVisable = true;
    },
    handleCloseTip() {
      this.dialogVisable = false;
    },
    handConfirm() {
      console.log("ok");
    },

    getVoices(audioclass_id) {
      Mp3Http.getVoices({
        member_id: this.$store.state.member_id,
        token: this.$store.state.token,
        student_id: this.student_id,
        audioclass_id
      }).then(res => {
        if (res.data.error == 0) {
          this.mp3List = res.data.result.list;
        } else {
          this.mp3List = [];
        }
      });
    }
  }
};
</script>
<style lang="less">
.review-questions {
  height: 100%;
  .prop-content {
    display: flex;
    align-items: center;
    justify-content: center;
    .gold {
      width: 26px;
      height: 26px;
      margin-right: 10px;
      background-color: red;
      border-radius: 50%;
      background: url(../../../../assets/images/studyCenter/questions/gold-icon.png)
        center center no-repeat;
      background-size: cover;
    }
  }
}
</style>